export const routes = {
  public: {
    signIn: "signin",
    signUp: "signup",
    forgotPassword: "forgot-password",
    setPassword: "set-password",
    resetConfirm: "confirmation",
    signUpConfirm: "signup-confirmation",
    autoLogin: "auto-login",
    notAuthorized: "not-authorized",
  },
} as const;
